<template>
  <Poptip placement="bottom-start" width="480" @on-popper-show="show" @on-popper-hide="hide">
    <a href="javascript:void(0)" ref="poptipBtn" v-show="value.length==0">选择</a>
    <div style="display:inline-block">
      <transition-group name="list" tag="p">
        <Tag closable v-for="(val, ind) in value" :key="ind" @click.native="active(ind)" @on-close="remove(val)">{{val}}</Tag>
      </transition-group>
    </div>
    <div class="api" slot="content" style="width:448px;text-align:left;height:190px;padding-top:10px;overflow: auto">
      <div v-show="cityShow">
        <template v-for="(item,ind) in city">
        <div :key="ind" style="margin:0 5px 5px 0;float:left">
          <Button style="padding:4px 10px" @click="selCity(item)" size="small" :type="value.indexOf(item.value)>=0?'primary':'default'">{{item.value}}</Button>
        </div>
        </template>
      </div>
      <div v-show="areaShow">
        <template v-for="(item, ind) in area">
        <div style="margin:0 5px 5px 0;float:left" :key="ind" v-if="item.value!='请选择'">
          <Button style="padding:4px 10px" @click="selArea(item)" size="small" :type="value.indexOf(item.value)>=0?'primary':'default'">{{item.value}}</Button>
        </div>
        </template>
      </div>
      <div v-show="countyShow">
        <template v-for="(item, ind) in county">
        <div style="margin:0 5px 5px 0;float:left" :key="ind" v-if="item.value!='请选择'">
          <Button style="padding:4px 10px" @click="selCounty(item)" size="small" :type="value.indexOf(item.value)>=0?'primary':'default'">{{item.value}}</Button>
        </div>
        </template>
      </div>
    </div>
  </Poptip>
</template>

<script>
import city from '../util/city'
export default {
  name: 'CitySelect',
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      visible: false,
      select: [],
      city: city,
      area: [],
      county: [],
      cityShow: true,
      areaShow: false,
      countyShow: false
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    active (ind) {
      if (!this.visible) this.$refs.poptipBtn.click()
      this.toggle(ind)
    },
    toggle (len) {
      if (len === 0) {
        this.cityShow = true
        this.areaShow = false
        this.countyShow = false
      } else if (len === 1) {
        this.cityShow = false
        this.areaShow = true
        this.countyShow = false
      } else if (len === 2) {
        this.cityShow = false
        this.areaShow = false
        this.countyShow = true
      }
    },
    remove (val) {
      let ind = this.select.indexOf(val)
      if (ind === 0) {
        this.select = []
      } else if (ind === 1) {
        this.select.splice(2, 1)
        this.select.splice(1, 1)
      } else {
        this.select.splice(2, 1)
      }

      this.$emit('input', this.select)
      let len = this.select.length
      this.toggle(len)
    },
    selCity (item) {
      this.select = []
      this.select.push(item.value)
      this.$emit('input', this.select)
      if (item.child.length) {
        this.cityShow = false
        this.areaShow = true
        this.area = item.child
      }
    },
    selArea (item) {
      this.select.splice(2, 1)
      this.select.splice(1, 1)
      this.select.push(item.value)
      this.$emit('input', this.select)
      if (item.child) {
        this.areaShow = false
        this.countyShow = true
        this.county = item.child
      }
    },
    selCounty (item) {
      this.select.splice(2, 1)
      this.select.push(item.value)
      this.$emit('input', this.select)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all .5s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
</style>
